<template>
    <div class="knowledge-asset-article">
        <storage-image
                v-if="hasStoredCover"
                keep-aspect-ratio
                :file="storedCover"
        />

        <b-img
                v-else
                :src="coverPlaceholder"
                class="cover-placeholder"
        />
        <div
                class="article-content"
                :class="{'over-image': contentOverImage}"
        >
            <h1 class="text-center">
                {{ asset.title }}
            </h1>

            <landing-page-event-details
                class="my-4"
                v-if="hasEvent && event && event.exists"
                :event="event"
            />

            <div
                class="article-overview"
                v-if="asset.overview"
            >
                <p
                    class="article-overview-title"
                >
                    SUMMARY
                </p>

                <p
                    v-if="asset.overview"
                    class="article-overview-content mb-0"
                >
                    {{ asset.overview }}
                </p>
            </div>

            <div
                    class="article-body"
                    v-html="asset.articleMainBody"
            />
            <p
                    v-if="asset.disclaimer"
                    class="article-disclaimer mb-0"
            >
                <b>Disclaimer</b> {{ asset.disclaimer }}
            </p>
            <div class="article-tags">
                <tag
                        v-for="(tag, index) in asset.tags"
                        :key="index"
                >
                    {{ tag.tag }}
                </tag>
            </div>
        </div>
    </div>
</template>

<script>
    import './Article.scss';
    import {KNOWLEDGE_ASSET} from "../../../../../helpers/images";
    import StorageImage from "../../../../StorageImage/StorageImage";
    import Tag from "../../Tag/Tag";
    import LandingPageEventAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageEventAppResource";
    import LandingPageEventDetails from "../../../LandingPageEventDetails/LandingPageEventDetails";

    export default {
        name: "Article",
        components: {
            LandingPageEventDetails,
            Tag,
            StorageImage
        },
        props: {
            asset: {
                type: Object,
                required: true,
            },
            contentOverImage: {
                type: Boolean,
                default: false,
            },
            event: {
                type: LandingPageEventAppResource,
                default: () => new LandingPageEventAppResource({}),
            },
            hasEvent: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
        computed: {
            hasStoredCover() {
                return !!this.asset.files.length;
            },

            storedCover() {
                return this.hasStoredCover ? this.asset.files.toArray()[0] : {};
            },

            coverPlaceholder() {
                return KNOWLEDGE_ASSET.COVER;
            },
        }
    };
</script>

